import React from "react";
import { EvtHeader } from "components/header";
import TicketForm from "../form";
import { useParams } from "react-router-dom";

export default function UpdateTicket() {
  const { ticketId } = useParams();
  return (
    <div className="flex-1">
      <EvtHeader title="Edit Ticket" />
      <div className="max-w-md p-4 lg:p-6">
        <TicketForm ticketId={ticketId} />
      </div>
    </div>
  );
};
